module.exports = __webpack_public_path__ + "dk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/dk.svg
// module id = 519
// module chunks = 0